import { render, staticRenderFns } from "./PortineriaControlliView.vue?vue&type=template&id=9cd2ef42&"
import script from "./PortineriaControlliView.vue?vue&type=script&lang=ts&"
export * from "./PortineriaControlliView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports